module.exports = __webpack_public_path__ + "static/media/camera.d31cb7f3.png";